import { render, staticRenderFns } from "./reviewTab.vue?vue&type=template&id=c716efae&lang=pug"
import script from "./reviewTab.vue?vue&type=script&lang=js"
export * from "./reviewTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports